export const capitalizeFirstLetter = (str: string) =>
  (str.charAt(0).toUpperCase() + str.slice(1))?.replace(/ /g, '');

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
